
/**
 * The purpose of this is file is to share variables between
 * CSS and JS. E.g
 * 	In css: $primaryColor
 * 	in JS:
 * 		let variables = require('./variables.js');
 * 		console.log(variables.primaryColor);
 *
 * Note that PostCSS does not allow you to reat properties of
 * variables so values must be simple (string, numbers, ...)
 * and not objects.
 */
module.exports = {
	screen_wrapper: 		'1400px',
	screen_tablet: 			'768px',
	screen_mobileMenu: 		'870px',
	screen_mobile: 			'640px',
	screen_linear: 			'460px',
	color_COMPLETE: 		'#D2582B',
	color_DISTRESSED: 		'#80BD68',
	color_PARTIAL: 			'#37445C',
	color_MERGE_IN: 		'#8A0F0F',
	color_MOVE_AND_ACQUIRE: '#005985',
	color_SELL_AND_CONSULT: '#F0B138',
	color_DEFAULT: 			'#999999'
};